import type { ButtonProps } from '@mui/material/Button';

import { RouterLink } from '@/routes/components';
import Button from '@mui/material/Button';

// ----------------------------------------------------------------------

export function SignInButton({ sx, ...other }: ButtonProps) {
  const handleRedirect = () => {
    window.location.href = process.env.REACT_APP_PRODUCT_WEBAPP_URI || '';
  };

  return (
    <Button
      component={RouterLink}
      variant="outlined"
      onClick={handleRedirect}
      sx={{ ...sx, borderRadius: 0 }}
      {...other}>
      Sign in
    </Button>
  );
}
